import { notification } from 'antd';
import { AppContext } from 'App.context';
import { useContext, useEffect, useState } from 'react';
import constants from 'utils/constants';
import { ApiContext } from 'utils/networking/Api.context';

export default function usePoliceReportSFTPConfigHook(type = 'PV') {
  const {
    appState,
    appActions: { getSelectedHotel, translate },
  } = useContext(AppContext);
  const { API } = useContext(ApiContext);

  const [state, setState] = useState({
    isLoading: false,
    dateSelected: null,
    bookingProvider: null,
  });

  useEffect(() => {
    actions.loadPoliceReportConfig();
  }, [appState.selectedHotel]);

  const actions = {
    loadPoliceReportConfig: async () => {
      try {
        updateState({ isLoading: true });
        const res =
          type === 'PV'
            ? await API.getPoliceConfig({ hotelId: getSelectedHotel()?.key })
            : await API.getBookingReportConfig({ hotelId: getSelectedHotel()?.key });

        updateState({
          isLoading: false,
          dateSelected: res?.dateSelected,
          bookingProvider: res?.bookingProvider,
        });
      } catch (err) {
        console.warn(err);
        updateState({ isLoading: false });
      }
    },

    onSaveFTPConfig: async () => {
      try {
        updateState({ isLoading: true });

        await API.updatePoliceSFTP({
          type: type,
          hotelId: getSelectedHotel()?.key,
          bookingProvider: constants.BOOKING_PROVIDER.API,
          ftpConfig: {
            host: null,
            user: null,
            password: null,
            port: null,
            dateSelected: null,
          },
          fileFormat: 'YYYY-MM-DD.txt',
          filePrefix: null,
          fileSufix: null,
          ftpDirPath: null,
        });

        updateState({ isLoading: false });
        notification.success({
          message: translate('policeReport.saveConfigSuccess'),
        });

        await actions.loadPoliceReportConfig();
      } catch (err) {
        console.warn(err);
        updateState({ isLoading: false });
        notification.error({
          message: translate('policeReport.saveConfigError'),
        });
      }
    },

    isAdmin: () => appState?.superUser ?? false,
  };

  function updateState(object) {
    setState(prev => ({ ...prev, ...object }));
  }

  return { state, actions };
}
